import approvals from "./approvals";

export default {
    approvals: approvals
}